import { QueryClient } from '@tanstack/react-query';
import { matchKeys } from '@/services/api/matchesV2';
import { getV2Error } from '@/services/api/v2';

export const refreshMatchCapabilitiesOnForbidden = (error: unknown, client: QueryClient, workspaceId: string, id: string): void => {
  if (getV2Error(error).code === 'forbidden') void client.invalidateQueries({ queryKey: matchKeys.manual(workspaceId, id) });
};
